export default "__VITE_ASSET__c24f9758__"